import { render, staticRenderFns } from "./error_page.vue?vue&type=template&id=b19e2a48"
import script from "./error_page.vue?vue&type=script&lang=js"
export * from "./error_page.vue?vue&type=script&lang=js"
import style0 from "./error_page.vue?vue&type=style&index=0&id=b19e2a48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports